import React from 'react';
import InstallationType from '../../controls/installation/InstallationType';
import ExteriorType from '../../controls/installation/ExteriorType';
import BrickmoldSize from '../../controls/installation/BrickmoldSize';
import BrickmoldColor from '../../controls/installation/BrickmoldColor';
import JambType from '../../controls/installation/JambType';
import InteriorCasing from '../../controls/installation/InteriorCasing';
import InteriorCasingSize from '../../controls/installation/InteriorCasingSize';
import FrameDepth from '../../controls/installation/FrameDepth';

export const getInstallationSection = (props) => {
  const {
    SECTIONS,
    isDisabled,
    installationTypeValue, setInstallationTypeValue,
    exteriorTypeValue, setExteriorTypeValue,
    brickmoldSizeValue, setBrickmoldSizeValue,
    brickmoldColorValue, setBrickmoldColorValue,
    jambTypeValue, setJambTypeValue,
    interiorCasingValue, setInteriorCasingValue,
    interiorCasingSizeValue, setInteriorCasingSizeValue,
    frameDepthValue, setFrameDepthValue
  } = props;

  return [
    // Installation section starts ...
    { id: "InstallationType",    component: 1 > SECTIONS ? null : ( <InstallationType
      disabled={isDisabled} id = {"InstallationType"}  showPics={false}
      value={installationTypeValue}    onChange={(newValue) => { setInstallationTypeValue(newValue); }
    }/>), position: [1, 1], status: "active", expandableSectionId: "Installation" },

    // ExteriorType: Hide only if InstallationType is "None"
    // Shows different options based on InstallationType:
    // - "Brick to Brick" → only "Brickmold"
    // - "Retrofit" or "Stud-to-Stud" → "None" and "Capping"
    (installationTypeValue?.value !== "None") &&
    { id: "ExteriorType",    component: 1 > SECTIONS ? null : ( <ExteriorType
      disabled={isDisabled} id = {"ExteriorType"}  showPics={false}
      hideOptions={installationTypeValue?.value === "Brick to Brick" ? ["None", "Capping"] : ["Brickmold"]}
      value={exteriorTypeValue}    onChange={(newValue) => { setExteriorTypeValue(newValue); }
    }/>), position: [1, 2], status: "active", expandableSectionId: "Installation" },

    (installationTypeValue?.value !== "None") &&
    { id: "FrameDepth",    component: 1 > SECTIONS ? null : ( <FrameDepth
      disabled={isDisabled} id = {"FrameDepth"} 
      value={frameDepthValue}    onChange={(newValue) => { setFrameDepthValue(newValue); }
    }/>), position: [1, 3], status: "active", expandableSectionId: "Installation" },

    // BrickmoldSize: Only show if InstallationType is "Brick to Brick"
    (installationTypeValue?.value === "Brick to Brick") &&
    { id: "BrickmoldSize",    component: 1 > SECTIONS ? null : ( <BrickmoldSize
      disabled={isDisabled} id = {"BrickmoldSize"}  showPics={false}
      value={brickmoldSizeValue}    onChange={(newValue) => { setBrickmoldSizeValue(newValue); }
    }/>), position: [2, 1], status: "active", expandableSectionId: "Installation" },

    // BrickmoldColor: Only show if InstallationType is "Brick to Brick"
    (installationTypeValue?.value === "Brick to Brick") &&
    { id: "BrickmoldColor", component: <BrickmoldColor controlId={2}
      disabled={isDisabled}
      value={brickmoldColorValue}
      onChange={(newValue) => { setBrickmoldColorValue(newValue); }
    }/>, position: [2, 2], status: "active", expandableSectionId: "Installation" },

    // JambType: Hide if InstallationType is "None"
    (installationTypeValue?.value !== "None") &&
    { id: "JambType",    component: 1 > SECTIONS ? null : ( <JambType
      disabled={isDisabled} id = {"JambType"}  showPics={false}
      value={jambTypeValue}    onChange={(newValue) => { setJambTypeValue(newValue); }
    }/>), position: [3, 1], status: "active", expandableSectionId: "Installation" },

    // InteriorCasing: Hide if InstallationType is "None"
    (installationTypeValue?.value !== "None") &&
    { id: "InteriorCasing",    component: 1 > SECTIONS ? null : ( <InteriorCasing
      disabled={isDisabled} id = {"InteriorCasing"}  showPics={false}
      value={interiorCasingValue}    onChange={(newValue) => { setInteriorCasingValue(newValue); }
    }/>), position: [3, 2], status: "active", expandableSectionId: "Installation" },

    // InteriorCasingSize: Hide if InstallationType is "None" or if InteriorCasing is "None"
    (installationTypeValue?.value !== "None") && (interiorCasingValue?.value !== "None") &&
    { id: "InteriorCasingSize",    component: 1 > SECTIONS ? null : ( <InteriorCasingSize
      disabled={isDisabled} id = {"InteriorCasingSize"}  showPics={false}
      value={interiorCasingSizeValue}    onChange={(newValue) => { setInteriorCasingSizeValue(newValue); }
    }/>), position: [3, 3], status: "active", expandableSectionId: "Installation" },
    // Installation ends ...
  ];
};
